import dayjs from 'dayjs';
import { Product } from '../types/product';
import CalendarDays from './icons/CalendarDays';
import PencilOutline from './icons/PencilOutline';
import { translateMark } from './ProductComponent';
import Badge from './ui/Badge';
import Button from './ui/Button';
import IconButton from './ui/IconButton';

type ProductBigComponentProps = {
  product: Product;
  withMarks?: boolean;
  children?: any;
  onEdit?: () => void;
};

const ProductBigComponent = (props: ProductBigComponentProps) => {
  return (
    <div className="flex flex-col space-y-4">
      <div className="flex flex-row justify-between">
        <p className="text-white">
          <b>
            <p className={`${props.withMarks && props.product.marked?.mark === 'BOUGHT' ? 'line-through' : ''}`}>
              {props.product.name}
            </p>
          </b>
        </p>
        {props.onEdit && (
          <IconButton onClick={() => props.onEdit && props.onEdit()} Icon={PencilOutline} variant="primary-muted" />
        )}
      </div>
      <div className="flex flex-row justify-between">
        <div className="flex flex-row space-x-4 ">
          {props.product.imageUrl ? (
            <div
              style={{
                backgroundImage: `url(${props.product.imageUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
              className="h-40 w-40 rounded-full shrink-0"
            />
          ) : (
            <span className="flex flex-col h-40 w-40 bg-white rounded-full justify-center text-center text-xl shrink-0">
              {props.product.name[0]}
            </span>
          )}
          <div className="space-y-2 flex-wrap">
            <p className="text-gray-400">
              {props.product.price ? `${props.product.price?.toLocaleString()} €` : '-- €'}
            </p>
            {props.withMarks && props.product.marked?.mark && <Badge>{translateMark(props.product.marked.mark)}</Badge>}
            <p className="text-gray-400 flex-wrap break-all">{props.product.comment}</p>
            <div className="flex flex-row text-gray-400 text-xs space-x-1 items-center">
              <CalendarDays />
              <span>Hinzugefügt {dayjs(props.product.addedAt).format('DD.MM.YYYY')}</span>
            </div>
          </div>
        </div>
      </div>
      {props.product.url && (
        <div className="flex flex-row justify-center md:justify-start">
          <Button variant="alternative" onClick={() => window.open(props.product.url, '_blank')}>
            Zum Produkt
          </Button>
        </div>
      )}
    </div>
  );
};

export default ProductBigComponent;
